import {
    Deferred,
    EventBus,
    format,
    Instance,
    Objekt,
    Script,
    Service,
} from '@siposdani87/sui-js';
import { app } from '../app';
import { ConfigService } from './configService';

export class FacebookPixelService extends Service {
    static readonly inject = ['instances', 'configService'];

    script: Script;
    eventBus: EventBus;

    constructor(
        instances: Instance,
        private configService: ConfigService,
    ) {
        super();

        this.script = instances.script;
        this.eventBus = instances.eventBus;
    }

    enter(): void {
        this.eventBus.set('state.change', (state: Objekt) => {
            const url = state.get<string>('url');
            this.sendPageView(url);
        });

        this._loadSDK();
    }

    private _asyncInit() {
        const deferred = new Deferred();
        if ((window as any)['fbq']) {
            (window as any)['fbq'](
                'init',
                this.configService.get<string>('facebook.pixel_id'),
            );
            (window as any)['fbq']('track', 'PageView');
            deferred.resolve();
        } else {
            deferred.reject();
        }
        return deferred.promise();
    }

    private _loadSDK() {
        const deferred = new Deferred();

        const n = ((window as any)['fbq'] = function (...args: any[]) {
            if ((n as any)['callMethod']) {
                (n as any)['callMethod']['apply'](n, args);
            } else {
                (n as any)['queue']['push'](args);
            }
        });
        if (!(window as any)['_fbq']) {
            (window as any)['_fbq'] = n;
        }
        (n as any)['push'] = n;
        (n as any)['loaded'] = true;
        (n as any)['version'] = '2.0';
        (n as any)['queue'] = [];

        const locale = this.configService.getLocale().replace('-', '_');
        this.script
            .load(
                'facebook-pixel-sdk',
                format('//connect.facebook.net/{0}/fbevents.js', [locale]),
            )
            .then(
                () => {
                    this._asyncInit().defer(deferred);
                },
                () => {
                    // If bocked by AdBlocker
                    deferred.resolve();
                },
            );
        return deferred.promise();
    }

    reset(): void {
        this.script.remove('facebook-pixel-sdk');
    }

    sendPageView(url: string): void {
        if ((window as any)['fbq']) {
            (window as any)['fbq']('trackCustom', 'virtualPageview', {
                url: url,
            });
        }
    }

    track(eventName: string, opt_params?: object): void {
        if ((window as any)['fbq']) {
            (window as any)['fbq']('track', eventName, opt_params);
        }
    }
}

export const facebookPixelService = app.service('facebookPixelService', FacebookPixelService);
